import { useEffect } from 'react';

import { useForm } from 'react-hook-form';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { sendUserOtpLogin } from '../../slices/auth.slice';
import { useAppDispatch } from '../../store/hooks';
import { OtpLoginI } from '../../utils/interface';
import OtpLoginContainer from './OtpLogin';

const OtpLogin = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const qrCode = location?.state?.qrCode;

  const [qParams] = useSearchParams();
  const token = qParams.get('token');

  const { control, handleSubmit, watch, setValue } = useForm<OtpLoginI>({
    defaultValues: {
      digits: ['', '', '', '', '', ''],
    },
  });
  const digits = watch('digits') || ['', '', '', '', '', ''];

  const onSubmit = (data: OtpLoginI) => {
    const finalData = { token, otp: data.digits?.join('') };
    dispatch(sendUserOtpLogin({ finalData, navigate, toast }));
  };

  useEffect(() => {
    if (digits.every((digit: string) => digit && digit !== '')) {
      handleSubmit(onSubmit)();
    }
  }, [digits, handleSubmit]);

  const handleChange = (event: any, index: number) => {
    const value = event.target.value;
    if (/^\d?$/.test(value)) {
      const newDigits = [...digits];
      newDigits[index] = value;
      setValue('digits', newDigits);

      if (value && index < 5) {
        document.getElementById(`digit-${index + 1}`)?.focus();
      }
    }
  };

  const handleKeyDown = (event: any, index: number) => {
    if (event.key === 'Backspace' && !digits[index]) {
      if (index > 0) {
        const newDigits = [...digits];
        newDigits[index - 1] = '';
        setValue('digits', newDigits);
        document.getElementById(`digit-${index - 1}`)?.focus();
      }
    }
  };

  return (
    <form>
      <OtpLoginContainer
        control={control}
        handleChange={handleChange}
        handleKeyDown={handleKeyDown}
        isApiLoading={false}
        qrCode={qrCode}
        logoUrl={''}
      />
    </form>
  );
};

export default OtpLogin;
